import axios from "axios";

const trackEvent = async (eventName, metadata = {}) => {
  try {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    await axios.post("/api/app_events", {
      event: {
        event_name: eventName,
        event_type: "action",
        metadata: metadata,
      },
    }, {
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    // Don't break UX if tracking fails
  }
};

export default trackEvent;
